import { FinanceModel } from "../models/FinanceModel";
import API, { client } from "./API";

const FinanceService = {
  async getAllFinances() {
    const response = await API().get("Finance", {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async getParticularFinance(finance_id: number) {
    const response = await API().get("Finance");
    return response.data.filter(
      (cur_finance: FinanceModel) => cur_finance.fundingSourceId === finance_id
    )[0];
  },
  async createFinance(data: FinanceModel, id?: number) {
    try {
      const response = await client({
        method: id ? "put" : "post",
        url: id ? `Finance/${id}` : "Finance",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default FinanceService;